export default "__VITE_ASSET__pExa69yv__"